import { ICommand, IDefineCommand } from 'core-ts-types';
import { IMemberConfiguration } from '../configuration/member_configuration';
import { MemberDatasource } from '../datasources/member_datasource';

angular.module('capability-ng-global').factory(
  'loadMemberConfigurationCommand',
  (
    defineCommand: IDefineCommand,
    $http: ng.IHttpService,
    ngMemberDatasource: MemberDatasource,
    ngMemberConfiguration: IMemberConfiguration,
    phxUniversityBrandingDelegate: any
  ): ICommand => {
    return defineCommand('loadMemberConfigurationCommand', (deferred: ng.IDeferred<IMemberConfiguration>): void => {
      $http
        .get('config/')
        .then(({ data: memberConfiguration }: any): void => {
          ngMemberDatasource.write(memberConfiguration.results);
          ngMemberConfiguration.write(memberConfiguration.results);
          ngMemberConfiguration.applyMember(ngMemberDatasource.read());

          const branding = ngMemberDatasource.read().branding;
          phxUniversityBrandingDelegate.update({
            primaryColor: branding.primary_color,
            secondaryColor: '#1E1E1E',
            textColor: '#FFFFFF',
            // HACK If you're thinking of adding more logic to this attribute, stop! Logic from this should go away.
            // We have it this way to accommodate ACU logo placement. Think of a way to get rid of this.
            additionalStyles: `
            header.university {
              background-color: ${branding.second_header_bar_color};
              color: ${branding.primary_color};
            }
            header.university.view-landing .uni-logo {
              background-image: url("${branding.header_logo}");
              height: ${branding.header_logo_height};
              width: ${branding.header_logo_width};
              background-position: ${branding.header_logo_placement == 'left' ? '' : '50%'};
              top: ${branding.header_logo_placement == 'left' ? '1.5rem' : '0'};
              left: ${branding.header_logo_placement == 'left' ? '2.0rem' : '50%'};
              transform: ${branding.header_logo_placement == 'left' ? '' : 'translateX(-50%)'};
            }

            header.university.view-landing:after {
              height: ${branding.first_header_bar_height};
              background-color: ${branding.first_header_bar_color};
            }
            footer.university.view-landing {
              background-color: ${branding.footer_color};
              height: ${branding.footer_height};
            }
            footer.university.view-landing .uni-logo {
              background-image: url("${branding.footer_logo}");
              width: ${branding.footer_logo_width};
              margin-top: ${branding.footer_logo_margin};
            }
            `
          });
          deferred.resolve(ngMemberConfiguration);
        })
        .catch((error: any): void => {
          deferred.reject(error);
        });
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/global/commands/load_member_configuration_command.ts